import { RealTime } from "./real-time";

import newPostSubscribe from "./subscribers/new-post";
import alertsSubscribe from "./subscribers/alerts";
import liveCommentsSubscribe from "./subscribers/live-comments";
import newConversationSubscribe from "./subscribers/conversations";
import telegramAuthSubscribe from "./subscribers/telegram-auth";
import notifyEverythingSubscribe from './subscribers/notify-everything';

/**
 * Инициализирует real time обмен сообщениями между клиентом и сервером
 * @function
 * @returns {RealTime}
 */
const getRealTime = () => {
  try {
    let user = document.querySelector('meta[name=centrifugo-user]').getAttribute('content');
    let url = document.querySelector('meta[name=centrifugo-url]').getAttribute('content');
    let token = document.querySelector('meta[name=centrifugo-token]').getAttribute('content');

    return new RealTime(url, token, user);
  } catch(e) {
    return false;
  }
};

const rt = getRealTime();

if (rt) {
  newPostSubscribe(rt); // новый пост
  alertsSubscribe(rt); // оповещения
  liveCommentsSubscribe(rt); // прямой эфир комментариев
  newConversationSubscribe(rt); // прямой эфир обсуждений
  telegramAuthSubscribe(rt); // авторизация с помощью телеграм
  notifyEverythingSubscribe(rt); // оповещения, присланные с помощью админки
}







